/* eslint-disable no-console */
import Vue from 'vue'
import App from './App.vue'

const theme = window.APP_THEME
console.log('theme', theme)

import(`./styles/theme-${theme}/theme.css`).then(() => {
  console.log(`Loaded css theme: ${theme}.`)
}).catch((err) => {
  console.error(`Failed to load theme: ${err}`)
})

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
